import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getNotifications,
  toggleNotifications,
} from "../../../utils/APICalls/APICalls";
import { toggleNotificationReqBody } from "../../../utils/types";

export const getCustomerNotifications = createAsyncThunk(
  "fetchNotifications",
  async ({ restaurantId }: { restaurantId: number }) => {
    const notification = await getNotifications(restaurantId);

    return notification.data;
  }
);

export const toggleCustomerNotifications = createAsyncThunk(
  "toggleNotifications",
  async (params: toggleNotificationReqBody) => {
    await toggleNotifications(params);
  }
);
